module.exports = __webpack_public_path__ + "static/media/under-construction.0fbee4d6.jpg";